module.exports = __webpack_public_path__ + "img/collection-weddingRingsMokumeGane.c9e350d.jpg";